export const INAPPROPRIATE_UI_FORM = 'INAPPROPRIATE_UI_FORM'
export const VEHICLE_INFO_NOT_FOUND_IN_REGISTRY = 'VEHICLE_INFO_NOT_FOUND_IN_REGISTRY'
export const SCROLL_TO_SIMPLIFIED_FORM_DELAY = 250
export const SAIL_FROM_URL_PREFIX = '?sail='
export const REMOVE_PROMOTION_ITEM_DELAY = 100
export const COMPANY_NUMBER_STATUS = {
  VERIFIED: 'verified',
  PENDING: 'pending',
}
